module.exports = __webpack_public_path__ + "static/cloud1-cfa3744a90cce03d1261e992d285242d.png";